import { render, staticRenderFns } from "./License.vue?vue&type=template&id=6ac4b8d2"
import script from "./License.vue?vue&type=script&lang=js"
export * from "./License.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ac4b8d2')) {
      api.createRecord('6ac4b8d2', component.options)
    } else {
      api.reload('6ac4b8d2', component.options)
    }
    module.hot.accept("./License.vue?vue&type=template&id=6ac4b8d2", function () {
      api.rerender('6ac4b8d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/License.vue"
export default component.exports